<template>
  <div class="basicInformation common_group">
    <div class="title">
      <img src="@/assets/images/informationIcon.png">
      <span>基础信息</span>
    </div>
    <el-form
      class="common_form"
      label-position="left"
      ref="basicInformation"
      :rules="rules"
      label-width="180px"
      :model="formData"
    >
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="申请人">
            <el-input v-model="formData.submitUser" disabled />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="填报时间">
            <el-input v-model="formData.submitTime" disabled />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="所属年份">
            <el-input v-model="formData.year" disabled />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="季度">
            <el-input v-model="formData.quarter" disabled />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="总结报告" prop="summaryLink">
            <el-input v-model.trim="formData.summaryLink" placeholder="请输入链接" clearable :disabled="isReadonly" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { isNotEmpty } from '@/utils/utils';
import { QUARTER_PERIODS } from '@/utils/constants';
const dayjs = require('dayjs');
export default {
  name: 'BasicInformation',
  data () {
    return {
      rules: {
        summaryLink: [
          { required: true, message: '请输入链接', trigger: 'blur' }
        ]
      },
      formData: {
        submitUser: '', // 申请人
        submitTime: dayjs().format('YYYY-MM-DD HH:mm:ss'), // 填报时间
        year: '', // 年度
        quarter: '', // 季度
        summaryLink: '' // 年度整合营销规划文档
      }
    };
  },
  props: {
    editEchoData: {
      type: Object,
      default: () => {}
    },
    isReadonly: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    editEchoData: {
      handler (newVal) {
        if (isNotEmpty(newVal)) {
          this.formData = {
            submitUser: newVal.submitUserName ? `${newVal.submitUserName} / ${newVal.submitDeptName}` : '',
            submitTime: this.$route.path === `/quarterlyFilingDetails` ? newVal.submitTime : dayjs().format('YYYY-MM-DD HH:mm:ss'),
            year: newVal.year || '',
            quarter: newVal.quarter || '',
            summaryLink: newVal.summaryLink || ''
          };
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    validateHandler () {
      return new Promise((resolve, reject) => {
        this.$refs['basicInformation'].validate((valid) => {
          if (valid) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    }
  },
  mounted () {
    let userInfo = this.$store.state.userInfo;
    // 申请人
    this.formData.submitUser = `${userInfo.sysUser.userName} / ${userInfo.sysUser.deptName}`;
    this.formData.year = this.$route.query.year;
    const index = QUARTER_PERIODS.findIndex(item => item.key === this.$route.query.quarter);
    this.formData.quarter = QUARTER_PERIODS[index].label;
  }
};
</script>

<style scoped>

</style>
